/// <amd-module name="DistributedTask/Subscriptions/Models/Subscription" />
import { ISubscriptionAccount, PurchaseErrorReason } from "Contracts/Commerce";
import * as SubscriptionResources from "DistributedTask/Subscriptions/Resources";

export class Subscription {
    private internalSubscriptionAccount: ISubscriptionAccount;
    private internalHasBeenValidated: boolean;

    constructor(subscriptionAccount: ISubscriptionAccount, isValidated?: boolean) {
        this.internalSubscriptionAccount = subscriptionAccount;
        this.internalHasBeenValidated = !!isValidated;
    }

    public get id(): string {
        return this.subscriptionAccount.subscriptionId;
    }

    public get displayName(): string {
        return this.subscriptionAccount.subscriptionName;
    }

    public get isUsable(): boolean {
        return !this.hasBeenValidated || this.invalidReason === undefined;
    }

    public get hasBeenValidated() {
        return this.internalHasBeenValidated;
    }

    public get invalidReason(): string | undefined {
        switch (this.internalSubscriptionAccount.failedPurchaseReason) {
            case PurchaseErrorReason.None:
                return undefined;
            case PurchaseErrorReason.MonetaryLimitSet:
                return SubscriptionResources.SubscriptionHasSpendingLimit;
            case PurchaseErrorReason.NotAdminOrCoAdmin:
            case PurchaseErrorReason.NotSubscriptionUser:
                return SubscriptionResources.NeedsToBeAdminOrCoAdminOnSubscription;
            case PurchaseErrorReason.InvalidOfferRegion:
                return SubscriptionResources.SubscriptionNotAvailableInRegion;
            case PurchaseErrorReason.PaymentInstrumentNotCreditCard:
                return SubscriptionResources.SubscriptionNeedsCreditCard;
            case PurchaseErrorReason.DisabledSubscription:
                return SubscriptionResources.SubscriptionNoLongerActive;
            case PurchaseErrorReason.UnsupportedSubscription:
                return SubscriptionResources.SubscriptionDeprecatedBilling;
            case PurchaseErrorReason.UnsupportedSubscriptionCsp:
                return SubscriptionResources.SubscriptionThroughCloudSolutionProvider;
            case PurchaseErrorReason.TemporarySpendingLimit:
                return SubscriptionResources.SubscriptionTempSpendingLimit;
            case PurchaseErrorReason.InvalidOfferRegion:
            case PurchaseErrorReason.InvalidOfferCode:
                return SubscriptionResources.SubscriptionCannotBeUsedForPurchases;
            default:
                return SubscriptionResources.SubscriptionCannotBeUsedForPurchases;
        }
    }

    public get subscriptionAccount(): ISubscriptionAccount {
        return { ...this.internalSubscriptionAccount };
    }
}
